import { hasPermission } from '../lib/permissionUtils';
import { useAuth } from '../context/AuthContext';

/**
 * Returns true when the authenticated user holds `perm`.
 *
 * Usage:
 *   const canReboot = usePermission('server.power');
 */
export function usePermission(perm: string): boolean {
  const { auth } = useAuth();
  return auth.status === 'authenticated' && hasPermission(auth.permissions, perm);
}
